import { render, staticRenderFns } from "./receipt_temp1.vue?vue&type=template&id=993ee67a&scoped=true"
import script from "./receipt_temp1.vue?vue&type=script&lang=js"
export * from "./receipt_temp1.vue?vue&type=script&lang=js"
import style0 from "./receipt_temp1.vue?vue&type=style&index=0&id=993ee67a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993ee67a",
  null
  
)

export default component.exports